export enum DealerLocatorLocation {
  Header = 'header',
  Body = 'body',
  Footer = 'footer'
}
